// extracted by mini-css-extract-plugin
export default {"toggleMenuItem":"styles_toggleMenuItem__VZ-A9"};